/**
 * 话题 ID 编解码 - 防止 URL 中的自增 ID 被批量爬虫利用
 * 将数字 ID 编码为不可猜测的字符串
 */

const SALT = 0x5A7B3C9D;

function base64urlEncode(buffer: Uint8Array): string {
  const base64 = btoa(String.fromCharCode.apply(null, Array.from(buffer)));
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function base64urlDecode(encoded: string): Uint8Array {
  const base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const bytes = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) {
    bytes[i] = raw.charCodeAt(i);
  }
  return bytes;
}

/**
 * 将数字 ID 编码为 URL 安全的字符串
 */
export function encodeId(id: number): string {
  // XOR 混合盐值后转为 4 字节 buffer
  const mixed = (id ^ SALT) >>> 0;
  const buffer = new Uint8Array([
    (mixed >> 24) & 0xff,
    (mixed >> 16) & 0xff,
    (mixed >> 8) & 0xff,
    mixed & 0xff,
  ]);
  return base64urlEncode(buffer);
}

/**
 * 将编码字符串解码为数字 ID
 */
export function decodeId(encoded: string): number | null {
  try {
    const buffer = base64urlDecode(encoded);
    if (buffer.length !== 4) return null;
    const view = new DataView(buffer.buffer);
    const mixed = view.getUint32(0, false); // big-endian
    return (mixed ^ SALT) >>> 0;
  } catch {
    return null;
  }
}
